// new code:-
// import React, { useEffect, useState } from 'react';
// import { useMain } from '../hooks/useMain';
// import {
//     CircularProgress,
//     Paper,
//     Typography,
//     Box,
// } from '@mui/material';
// import PageContainer from 'src/components/container/PageContainer';
// import { salarySlip } from 'src/context/contextPages/StaffContexts';

// // Utility function to get the current month name
// const getCurrentMonthName = () => {
//     const date = new Date();
//     const monthNames = [
//         'January', 'February', 'March', 'April', 'May', 'June',
//         'July', 'August', 'September', 'October', 'November', 'December'
//     ];
//     return monthNames[date.getMonth()];
// };

// const SalaryAndIncentive = () => {
//     const [data, setData] = useState(null);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const { branchId, activeStaffId } = useMain();
//     const [monthName, setMonthName] = useState(getCurrentMonthName()); // Dynamically set the month name

//     useEffect(() => {
//         const fetchData = async () => {
//             const queryParams = `?branchId=${branchId}&monthName=${monthName}`;
//             try {
//                 const result = await salarySlip(activeStaffId, queryParams);
//                 console.log(result); // Log the result to check the structure
//                 if (result && result.data) {
//                     setData(result.data);
//                 } else {
//                     throw new Error('Unexpected response format');
//                 }
//                 // setLoading(false);
//             } catch (error) {
//                 setError(error);
//                 // setLoading(false);
//             }
//         };

//         if (activeStaffId && branchId) {
//             fetchData();
//         }
//     }, [activeStaffId, branchId, monthName]); // Re-run effect if monthName changes

//     // if (loading) {
//     //     return (
//     //         <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
//     //             <CircularProgress />
//     //         </div>
//     //     );
//     // }

//     if (error) {
//         return <div>Error: {error.message}</div>;
//     }

//     return (
//         <PageContainer title="Salary and Incentive" description="View Salary and Incentive">
//             <Box sx={{ mb: 4 }}>
//                 <Typography variant="h4" sx={{ mb: 3 }}>
//                     Salary and Incentive
//                 </Typography>
//                 {data && (
//                     <Paper elevation={3} sx={{ p: 3 , m: 2, marginLeft:'2' }}>
//                         <Typography variant="h6" gutterBottom>Staff Name</Typography>
//                         <Typography variant="body1" sx={{ mb: 2 }}>{data.name}</Typography>

//                         <Typography variant="h6" gutterBottom>Email ID</Typography>
//                         <Typography variant="body1" sx={{ mb: 2 }}>{data.email}</Typography>

//                         <Typography variant="h6" gutterBottom>Salary Credited</Typography>
//                         <Typography variant="body1" sx={{ mb: 2 }}>{data.salary}</Typography>

//                         <Typography variant="h6" gutterBottom>Service Incentive</Typography>
//                         <Typography variant="body1" sx={{ mb: 2 }}>{data.serviceIncentive}</Typography>

//                         <Typography variant="h6" gutterBottom>Product Incentive</Typography>
//                         <Typography variant="body1" sx={{ mb: 2 }}>{data.productIncentive}</Typography>

//                         <Typography variant="h6" gutterBottom>Monthly Expense</Typography>
//                         <Typography variant="body1" sx={{ mb: 2 }}>{data.monthlyExpense}</Typography>

//                         <Typography variant="h6" gutterBottom>Payable Salary Amount</Typography>
//                         <Typography variant="body1">{data.payableSalaryAmount}</Typography>
//                     </Paper>
//                 )}
//             </Box>
//         </PageContainer>
//     );
// };

// export default SalaryAndIncentive;


import React, { useEffect, useState } from 'react';
import { useMain } from '../hooks/useMain';
import {
    Paper,
    Typography,
    Box,
} from '@mui/material';
import PageContainer from 'src/components/container/PageContainer';
import { salarySlip } from 'src/context/contextPages/StaffContexts';

// Utility function to get the current month name
const getCurrentMonthName = () => {
    const date = new Date();
    const monthNames = [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December'
    ];
    return monthNames[date.getMonth()];
};

const SalaryAndIncentive = () => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const { branchId, activeStaffId } = useMain();
    const monthName = getCurrentMonthName(); // Dynamically set the month name

    useEffect(() => {
        const fetchData = async () => {
            const queryParams = `?branchId=${branchId}&monthName=${monthName}`;
            try {
                const result = await salarySlip(activeStaffId, queryParams);
                console.log(result); // Log the result to check the structure
                if (result && result.data) {
                    setData(result.data);
                } else {
                    throw new Error('Unexpected response format');
                }
            } catch (error) {
                setError(error);
            }
        };

        if (activeStaffId && branchId) {
            fetchData();
        }
    }, [activeStaffId, branchId, monthName]); // Re-run effect if monthName changes

    if (error) {
        return <div>Error: {error.message}</div>;
    }

    return (
        <PageContainer title="Salary and Incentive" description="View Salary and Incentive">
            <Box sx={{ mb: 4 }}>
                <Typography variant="h4" sx={{ mb: 3 }}>
                    Salary and Incentive
                </Typography>
                {data && (
                    <Paper elevation={3} sx={{ p: 3, m: 2, marginLeft: '2' }}>
                        <Typography variant="h6" gutterBottom>Staff Name</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>{data.name}</Typography>

                        <Typography variant="h6" gutterBottom>Email</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>{data.email}</Typography>

                        <Typography variant="h6" gutterBottom>Salary Credited</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>{data.salary}</Typography>

                        <Typography variant="h6" gutterBottom>Service Incentive</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>{data.serviceIncentive}</Typography>

                        <Typography variant="h6" gutterBottom>Product Incentive</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>{data.productIncentive}</Typography>

                        <Typography variant="h6" gutterBottom>Monthly Expense</Typography>
                        <Typography variant="body1" sx={{ mb: 2 }}>{data.monthlyExpense}</Typography>

                        <Typography variant="h6" gutterBottom>Payable Salary Amount</Typography>
                        <Typography variant="body1">{data.payableSalaryAmount}</Typography>
                    </Paper>
                )}
            </Box>
        </PageContainer>
    );
};

export default SalaryAndIncentive;
